import React, { useState, useEffect, useRef } from 'react';      // <-- added useRef
import { loadStripe } from '@stripe/stripe-js';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo.svg';
import img1 from '../../images/membership/card1.jpg';
import img2 from '../../images/membership/card2.jpg';
import img3 from '../../images/membership/card3.jpg';
import img4 from '../../images/membership/card4.jpg';


const stripePromise = loadStripe('pk_live_51StkHS10FFqTErFO9O2MmiGgETUO7xM5REynnsumzjLGsgXxHt16PMR3ZieOLdert7ZZtUquFH01JXisKWSppRUv00b4FccCry');

// IMPORTANT: Replace 'price_1Tk2uAGNfk2BaaceQiDdurlJ' with a valid price that has `unit_amount: 200`.
// Also, ensure the subscription price IDs are valid and have amounts set.
const SUBSCRIPTIONS = [
  { id: 'price_1TofYV10FFqTErFOipmlsUx6', mode: 'subscription', name: 'Diamond', priceLabel: '$25,000', key: 'Diamond', color: '#507ec0', accent: 'linear-gradient(135deg,#f3f6f9,#eef2f6)',img:img4 },
  { id: 'price_1TofZa10FFqTErFO4sqjMtYP', mode: 'subscription', name: 'Platinum', priceLabel: '$15,000', key: 'platinum', color: '#7f8fa6', accent: 'linear-gradient(135deg,#f3f6f9,#eef2f6)' ,img:img1},
  { id: 'price_1TofaD10FFqTErFO1XJMbUMt', mode: 'subscription', name: 'Gold', priceLabel: '$10,000', key: 'gold', color: '#d4af37', accent: 'linear-gradient(135deg,#fff8e1,#fff4d6)' ,img:img3},
  { id: 'price_1Tofal10FFqTErFOFYtDii0m', mode: 'payment', name: 'Silver', priceLabel: '$5,000', key: 'silver', color: '#95a5a6', accent: 'linear-gradient(135deg,#f7f9fa,#f2f4f5)' ,img:img2},
];

// FIX THIS ONE: Ensure this price has `unit_amount: 200` in Stripe.
const ONETIMES = [
  { id: 'price_1Tk2uAGNfk2BaaceQiDdurlJ', mode: 'payment', label: 'one-time', key: 'one_2' },
];

const EventPagetwo = () => {
  const [loading, setLoading] = useState(false);
  const [processingTierId, setProcessingTierId] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);
  const [showCheckout, setShowCheckout] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const [thankYouMessage, setThankYouMessage] = useState('');

  // Ref to hold the current Embedded Checkout instance
  const checkoutRef = useRef(null);

  // Function to destroy the current checkout (if any)
  const destroyCheckout = () => {
    if (checkoutRef.current) {
      try {
        checkoutRef.current.destroy();   // Stripe's built-in cleanup
        checkoutRef.current = null;
        console.log('Embedded checkout destroyed');
      } catch (error) {
        console.warn('Error destroying checkout:', error);
      }
    }
  };

  // Cleanup on component unmount
  useEffect(() => {
    return () => {
      destroyCheckout();
    };
  }, []);

  // Step 1: Fetch the clientSecret from your PHP backend
  const handleSubscribe = async (tier) => {
    // If a checkout is currently open, destroy it before creating a new one
    destroyCheckout();

    setLoading(true);
    setProcessingTierId(tier.id);
    try {
      const response = await fetch('https://api.hearttoheartchildrensaid.org/create-checkout-session.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          priceId: tier.id,
          mode: tier.mode,
          membershipName: tier.name,
          membershipKey: tier.key,
        }),
      });
      
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || 'Server error');
      }

      // Store the client secret and show the embedded checkout container
      setClientSecret(data.clientSecret);
      setShowCheckout(true);
    } catch (error) {
      alert('Something went wrong: ' + error.message);
      console.error(error);
    } finally {
      setLoading(false);
      setProcessingTierId(null);
    }
  };

  // Step 2: Mount the Embedded Checkout whenever clientSecret is available
  useEffect(() => {
    if (!clientSecret || !showCheckout) {
      // If we're hiding checkout, ensure the instance is destroyed
      if (!showCheckout) {
        destroyCheckout();
      }
      return;
    }

    const mountCheckout = async () => {
      try {
        // Ensure any previous checkout is gone before mounting a new one
        destroyCheckout();

        const stripe = await stripePromise;
        const checkoutPage = await stripe.createEmbeddedCheckoutPage({
          clientSecret,
          onComplete: () => {
            console.log('Payment completed!');
            // If you set redirect_on_completion: 'never' in PHP,
            // you can handle success here (e.g., show a modal, then redirect)
          }
        });

        checkoutPage.mount('#embedded-checkout-container');
        checkoutRef.current = checkoutPage;   // store the instance for later cleanup
      } catch (error) {
        console.error('Failed to mount embedded checkout:', error);
        alert('Could not load payment page. Please try again.');
        // On error, reset state so the user can try again
        setShowCheckout(false);
        setClientSecret(null);
      }
    };

    mountCheckout();

    // Cleanup function for this effect: destroy checkout when clientSecret/showCheckout changes
    return () => {
      destroyCheckout();
    };
  }, [clientSecret, showCheckout]);

  // Step 3: Handle the return redirect (parse session_id from URL)
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('session_id');
    if (sessionId) {
      // Payment successful — send the session ID to backend to email customer,
      // then show a thank-you modal.
      (async () => {
        try {
          setLoading(true);
          // Close embedded checkout UI if open
          setShowCheckout(false);
          setClientSecret(null);
          destroyCheckout();

          const resp = await fetch('https://api.hearttoheartchildrensaid.org/send-thankyou-email.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ sessionId })
          });
          const data = await resp.json();
          if (!resp.ok) {
            console.warn('Email API returned error', data);
            setThankYouMessage('Thank you for your donation!');
          } else {
            setThankYouMessage('Thank you for your donation! A confirmation email has been sent.');
          }
        } catch (error) {
          console.error('Failed to send thank-you email:', error);
          setThankYouMessage('Thank you for your donation!');
        } finally {
          setLoading(false);
          setShowThankYou(true);
          // Clean up the URL without reloading the page
          window.history.replaceState({}, document.title, window.location.pathname);
        }
      })();
    }
  }, []);

  // Step 4: Go back to the donation options
  const handleBack = () => {
    destroyCheckout();          // explicitly destroy the checkout
    setShowCheckout(false);
    setClientSecret(null);
  };

  return (
    <>
      <Navbar Logo={Logo} hclass="wpo-site-header-s5" />
      <div style={{ textAlign: 'center', padding: '50px 20px' }}>
        <h1 className="mb-4">Help children build a brighter future</h1>

        {!showCheckout ? (
          <>
            {/* --- Your existing donation options --- */}
            <div style={{ display: 'flex', gap: '40px', flexWrap: 'wrap', justifyContent: 'center', marginTop: '30px' }}>
              <div style={{ minWidth: '320px' }}>
                <h2 style={{ marginBottom: '26px' }}>Become a Member</h2>
                <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                  {SUBSCRIPTIONS.map((tier) => (
                    <div key={tier.id} style={{ borderRadius: '12px', padding: '35px 20px', width: '220px', height: '350px', boxShadow: '0 6px 18px rgba(0,0,0,0.06)', border: '1px solid rgba(0,0,0,0.06)', background: tier.accent || '#fff', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                      <div>
                        <img src={tier.img} alt={tier.name} style={{ width: '100%', height: '130px', marginBottom: '12px', borderRadius: '8px' }} />
                        <div style={{ fontSize: '18px', fontWeight: 800, marginBottom: '6px' }}>{tier.name}</div>
                        <div style={{ fontSize: '16px', color: '#111', marginBottom: '12px' }}>{tier.priceLabel}</div>
                        <div style={{ color: '#777', fontSize: '13px', marginBottom: '14px' }}> Annual donation</div>
                      </div>
                      <button onClick={() => handleSubscribe(tier)} disabled={loading && processingTierId === tier.id} style={{ background: tier.color, color: '#fff', border: 'none', padding: '10px 18px', borderRadius: '8px', cursor: 'pointer', width: '100%' }}>
                        {loading && processingTierId === tier.id ? 'Processing...' : 'Donate'}
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
{/* 
            <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center' }}>
              <div style={{ minWidth: '320px' }}>
                <h2 style={{ marginBottom: '16px', textAlign: 'center' }}>One-Time Donations</h2>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', flexWrap: 'wrap' }}>
                  {ONETIMES.map((tier) => (
                    <div key={tier.id} style={{ border: '1px solid #eee', borderRadius: '12px', padding: '22px', width: '260px', boxShadow: '0 6px 18px rgba(0,0,0,0.04)', textAlign: 'center' }}>
                      <div style={{ fontSize: '20px', fontWeight: 700, marginBottom: '8px' }}>{tier.label}</div>
                      <div style={{ color: '#666', fontSize: '14px', marginBottom: '16px' }}>One-time donation</div>
                      <button onClick={() => handleSubscribe(tier)} disabled={loading} style={{ background: '#4a90e2', color: '#fff', border: 'none', padding: '10px 18px', borderRadius: '8px', cursor: 'pointer', width: '100%' }}>
                        {loading ? 'Processing...' : 'Donate Once'}
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div> */}
          </>
        ) : (
          // --- Embedded Checkout UI ---
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <button onClick={handleBack} style={{ background: 'transparent', border: 'none', color: '#4a90e2', cursor: 'pointer', fontSize: '16px', marginBottom: '20px' }}>
              ← Back to donation options
            </button>
            <div 
              id="embedded-checkout-container" 
              style={{ 
                minHeight: '500px', 
                border: '1px solid #ddd', 
                borderRadius: '12px', 
                padding: '20px',
                background: '#fff'
              }}
            />
          </div>
        )}

        {/* <p style={{ marginTop: '30px', fontSize: '14px', color: '#666' }}>
          {showCheckout ? 'Complete your donation securely below.' : 'You will be redirected to Stripe\'s secure payment page.'}
        </p> */}

        {showThankYou && (
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
            <div style={{ background: '#fff', padding: '24px', borderRadius: '12px', maxWidth: '480px', width: '90%', textAlign: 'center' }}>
              <h2 style={{ marginTop: 0 }}>Thank you</h2>
              <p style={{ color: '#333' }}>{thankYouMessage || 'Thank you for your support!'}</p>
              <button onClick={() => setShowThankYou(false)} style={{ marginTop: '12px', padding: '10px 16px', borderRadius: '8px', border: 'none', background: '#4a90e2', color: '#fff', cursor: 'pointer' }}>
                Close
              </button>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default EventPagetwo;